import React from 'react'

import Chart from './sparkline.d3'

export interface SparklineDataPoint {
    start: Date
    end: Date
    value: number
}
interface Props {
    data: SparklineDataPoint[]
}
class Graph extends React.Component<Props> {
    public static defaultProps = {
        data: [],
    }

    public chart: any = null

    public componentDidMount() {
        this.updateChart()
    }

    public componentDidUpdate() {
        this.updateChart()
    }

    public componentWillUnmount() {
        this.chart?.destroy()
    }

    public updateChart = () => {
        if (this.props.data.length && this.chart) {
            this.chart.update(this.props.data, [
                {
                    type: 'current',
                    start: this.props.data[this.props.data.length - 1].start,
                    end: this.props.data[this.props.data.length - 1].end,
                },
            ])
        }
    }

    public render() {
        return (
            <svg
                height="10px"
                width="10px"
                ref={svg => {
                    if (!svg) {
                        return
                    }

                    if (!this.chart) {
                        this.chart = new Chart()
                        const parentNode = jQuery(svg).parent()
                        this.chart.create(svg, parentNode.width(), Math.max(parentNode.height(), 20))
                    }
                }}
            />
        )
    }
}

export default Graph
